import React from "react";
// import { observer } from "mobx-react";

import { Dialog } from "../../components/index";
import homeStore from "../../stores/homeStore";

import "./dialog.scss";

interface Props {
  visible: boolean;
  id: string;
  onClose?: () => void;
  onSuccess?: () => void;
}

const SureDeleteDialog: React.FC<Props> = (props: Props) => {
  const { onClose = () => { }, onSuccess = () => { } } = props;
  const { setSureDelete } = homeStore();

  const onCancel = () => {
    onClose();
    setSureDelete(false);
  };

  return (
    <Dialog
      {...props}
      style={{ padding: "60px 33px 30px" }}
      onCancel={onCancel}
    >
      <div className="sure-delete-dialog">
        <p>确认删除当前内容？</p>
        <div className="sure-delete-dialog__btns">
          <div
            className="sure-delete-dialog__cancel--normal"
            onClick={() => onCancel()}
          >
            取消
          </div>
          <div
            className="sure-delete-dialog__delete"
            onClick={() => {
              onCancel();
              onSuccess();
            }}
          >
            删除
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SureDeleteDialog;
